import en from "./en"
import fr from "./fr"
import xps from '../xps/en';

const texts = {
  en: {
    title: 'Full-Stack Developer / Product Engineer',
    wait: 'Just a sencond, please...',
    greeting: `Hi! I'm Marson,`,
    askmission: 'My passion will help you pursue your ambitions. Need some help with those stacks?',
    contactme: 'Contact me',
    receivecv: 'Receive my CV',
    youremail: 'Your email',
    send: 'Send',
    bestprojs: 'Best projects',
    numberprojs: `+${xps.length} Done`,
    andcontinues: 'And it continues for',
  },
  fr: {
    title: 'Développeur / Ingénieur Produit Full-Stack',
    wait: 'Une seconde, svp...',
    greeting: `Je suis Marson,`,
    askmission: 'Ma passion vous aidera à poursuivre vos ambitions.',
    askmission2: 'Je peux vous aider sur ces Stacks ...',
    contactme: 'Contactez moi',
    receivecv: 'Recevoir mon CV',
    youremail: 'Votre email',
    send: 'Envoyer',
    bestprojs: 'Top des projets',
    numberprojs: `+${xps.length} Terminés`,
    andcontinues: 'Et ça continue pour',
  }
}



export const getText = (key, lang = 'fr') => texts[lang][key]
export default {en, fr}